import React, { useEffect } from "react";
import "../PrivacyPolicy/styles.css";
import "./styles.css";

const INTRO_ITEMS = [
  "1. 为保障伴知宠产品功能实现与安全稳定运行目的，我们可能会申请或使用操作系统的相关权限；",
  "2. 为保障您的知情权，我们通过下列列表将产品可能申请、使用的相关操作系统权限进行展示，您可以根据实际需要对相关权限进行管理；",
  "3. 根据产品的升级，申请、使用权限的类型与目的可能会有变动，我们将及时根据这些变动对列表进行调整，以确保您及时获悉权限的申请与使用情况；",
  "4. 请您知悉，我们为业务与产品的功能与安全需要，我们可能也会使用第三方SDK，这些第三方也可能会申请或使用相关操作系统权限，在您授权产品使用相关权限之前，第三方无法通过该权限获取到相关的信息；",
  "5. 在使用产品的过程中，您可能会使用第三方开发的H5页面或小程序，这些第三方开发的H5或小程序也可能因业务功能所必需而申请或使用相关操作系统权限；",
  "6. 以下适用伴知宠，如有单独适用的场景或目的将在下列列表说明。",
];

const IOS_PERMISSIONS = [
  {
    permName: "NSCameraUsageDescription",
    permLabel: "相机",
    purpose:
      "用于拍摄照片、录制视频，以便用户在使用相关功能时能够即时获取影像内容。",
    accessTimes: [
      "用户在“时光云相册”中拍摄照片或录制视频并发布",
      "用户在更换头像或封面时拍照",
      "用户在AI问答功能中上传图片（如拍摄宠物症状照片）",
      "用户与客服沟通时发送拍摄的图片",
      "用户使用扫码关注功能时扫描二维码",
      "用户通过APP远程查看智能硬件实时画面时",
    ],
    closeable: "是",
  },
  {
    permName: "NSMicrophoneUsageDescription",
    permLabel: "麦克风",
    purpose:
      "用于录制声音、语音输入及语音交互，支持语音记录、语音提问及远程语音对讲。",
    accessTimes: [
      "用户在“时光云相册”中发布录音",
      "用户在拍摄视频时录制声音",
      "用户在AI问答功能中使用语音输入提问",
      "用户在聊天或消息场景中使用语音录入消息",
      "用户与智能硬件进行双向语音对讲时",
    ],
    closeable: "是",
  },
  {
    permName: "NSBluetoothAlwaysUsageDescription\nNSBluetoothPeripheralUsageDescription",
    permLabel: "蓝牙",
    purpose:
      "用于发现、扫描并连接附近的伴知宠智能硬件设备，实现设备绑定与通信。",
    accessTimes: [
      "用户首次绑定智能陪伴车等智能硬件时，通过蓝牙进行近场配对",
      "用户在设备列表中扫描并获取附近智能设备信息时",
    ],
    closeable: "是",
  },
  {
    permName: "NSPhotoLibraryUsageDescription\nNSPhotoLibraryAddUsageDescription",
    permLabel: "相册",
    purpose:
      "用于访问本地相册中的照片、视频，以便用户上传、保存或管理媒体内容。",
    accessTimes: [
      "用户在“时光云相册”中从本地相册选择照片、视频上传",
      "用户在更换头像或封面时从相册选择图片",
      "用户在AI问答功能中上传相册中的图片",
      "用户保存APP内生成的图片或录制内容至本地",
      "用户在与客服沟通、回答评论时上传图片",
    ],
    closeable: "是",
  },
  {
    permName: "NSLocationWhenInUseUsageDescription\nNSLocationAlwaysUsageDescription",
    permLabel: "定位",
    purpose:
      "用于获取设备位置信息，以支持位置标记、辅助填写地址及设备联网配置。",
    accessTimes: [
      "用户在“时光云相册”发布记录时，主动选择保存地理位置",
      "用户在填写收货地址时，通过定位辅助输入地址信息",
      "用户在扫描并绑定智能设备时，获取附近Wi-Fi信息以完成设备联网配置",
      "智能硬件使用智能跟随、异常检测等功能时获取设备位置信息（用于路径规划）",
    ],
    closeable: "是",
  },
  {
    permName: "NSSpeechRecognitionUsageDescription",
    permLabel: "语音",
    purpose:
      "用于将用户的语音输入转换为文字，提升输入效率和交互便捷性。",
    accessTimes: [
      "用户在聊天或消息场景中主动选择使用语音录入消息时，将语音实时转换为文字",
    ],
    closeable: "是",
  },
];

const ANDROID_PERMISSIONS = [
  {
    permName: "CAMERA",
    permLabel: "相机",
    purpose:
      "用于拍摄照片、录制视频，以便用户在使用相关功能时能够即时获取影像内容。",
    accessTimes: [
      "用户在“时光云相册”中拍摄照片或录制视频并发布",
      "用户在更换头像或封面时拍照",
      "用户在AI问答功能中上传图片（如拍摄宠物症状照片）",
      "用户与客服沟通时发送拍摄的图片",
      "用户使用扫码关注功能时扫描二维码",
      "用户通过APP远程查看智能硬件实时画面时",
    ],
    closeable: "是",
  },
  {
    permName: "RECORD_AUDIO",
    permLabel: "麦克风",
    purpose:
      "用于录制声音、语音输入及语音交互，支持语音记录、语音提问及远程语音对讲。",
    accessTimes: [
      "用户在“时光云相册”中发布录音",
      "用户在拍摄视频时录制声音",
      "用户在AI问答功能中使用语音输入提问",
      "用户在聊天或消息场景中使用语音录入消息",
      "用户与智能硬件进行双向语音对讲时",
    ],
    closeable: "是",
  },
  {
    permName: "BLUETOOTH_CONNECT\nBLUETOOTH_SCAN",
    permLabel: "蓝牙",
    purpose:
      "用于发现、扫描并连接附近的伴知宠智能硬件设备，实现设备绑定与通信。",
    accessTimes: [
      "用户首次绑定智能陪伴车等智能硬件时，通过蓝牙进行近场配对",
      "用户在设备列表中扫描并获取附近智能设备信息时",
    ],
    closeable: "是",
  },
  {
    permName: "READ_MEDIA_IMAGES\nREAD_MEDIA_VIDEO",
    permLabel: "相册",
    purpose:
      "用于访问本地相册中的照片、视频，以便用户上传、保存或管理媒体内容。",
    accessTimes: [
      "用户在“时光云相册”中从本地相册选择照片、视频上传",
      "用户在更换头像或封面时从相册选择图片",
      "用户在AI问答功能中上传相册中的图片",
      "用户保存APP内生成的图片或录制内容至本地",
      "用户在与客服沟通、回答评论时上传图片",
    ],
    closeable: "是",
  },
  {
    permName: "ACCESS_FINE_LOCATION",
    permLabel: "定位",
    purpose:
      "用于获取设备位置信息，以支持位置标记、辅助填写地址及设备联网配置。",
    accessTimes: [
      "用户在“时光云相册”发布记录时，主动选择保存地理位置",
      "用户在填写收货地址时，通过定位辅助输入地址信息",
      "用户在扫描并绑定智能设备时，获取附近Wi-Fi信息以完成设备联网配置",
      "智能硬件使用智能跟随、异常检测等功能时获取设备位置信息（用于路径规划）",
    ],
    closeable: "是",
  },
];

function PermissionTable({ permissions }) {
  return (
    <table className="permission-table">
      <colgroup>
        <col className="col-perm" />
        <col className="col-purpose" />
        <col className="col-access" />
        <col className="col-close" />
      </colgroup>
      <thead>
        <tr>
          <th>设备权限</th>
          <th>使用目的</th>
          <th>访问时机</th>
          <th>是否可关闭</th>
        </tr>
      </thead>
      <tbody>
        {permissions.map((item, i) => (
          <tr key={i}>
            <td className="perm-name-cell">
              {item.permName.split("\n").map((line, idx) => (
                <span key={idx} className="perm-name-line">
                  {line}
                </span>
              ))}
              <span className="perm-label">{item.permLabel}</span>
            </td>
            <td>{item.purpose}</td>
            <td>
              <ul className="access-time-list">
                {item.accessTimes.map((t, j) => (
                  <li key={j}>{t}</li>
                ))}
              </ul>
            </td>
            <td className="closeable-cell">{item.closeable}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default function AppPermissionList() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className="privacy-policy-page app-permission-page"
      style={{ padding: "16px 12px", maxWidth: "960px", margin: "0 auto" }}
    >
      <h1>应用权限申请和使用情况说明</h1>

      <div className="permission-intro">
        {INTRO_ITEMS.map((text, i) => (
          <p key={i}>{text}</p>
        ))}
      </div>

      <h2>iOS App权限信息列表：</h2>
      <div className="permission-table-wrap">
        <PermissionTable permissions={IOS_PERMISSIONS} />
      </div>

      <h2>Android App权限信息列表：</h2>
      <div className="permission-table-wrap">
        <PermissionTable permissions={ANDROID_PERMISSIONS} />
      </div>
    </div>
  );
}
